import {BaseCarrierUiExtension} from "./baseCarrierUiExtension";
import {DostavistaCarrierUiExtension} from "./dostavistaCarrierUiExtension";

const baseExtension = new BaseCarrierUiExtension();
const registry = {
    dostavista: new DostavistaCarrierUiExtension()
};

const resolveCarrierCode = (tariff) => {
    if (!tariff) {
        return null;
    }
    if (tariff.carrierCode) {
        return tariff.carrierCode;
    }
    if (tariff.displayData && tariff.displayData.carrierCode) {
        return tariff.displayData.carrierCode;
    }
    if (tariff.carrierName && String(tariff.carrierName).toLowerCase().includes('dostavista')) {
        return 'dostavista';
    }
    if (tariff.displayData && tariff.displayData.carrierName
        && String(tariff.displayData.carrierName).toLowerCase().includes('dostavista')) {
        return 'dostavista';
    }
    return null;
};

export const getCarrierUiExtension = (tariff) => {
    const carrierCode = resolveCarrierCode(tariff);
    if (!carrierCode) {
        return baseExtension;
    }

    const normalizedCarrierCode = String(carrierCode).toLowerCase();
    if (registry[normalizedCarrierCode]) {
        return registry[normalizedCarrierCode];
    }

    // Защита от вариантов вроде "Dostavista Cargo", "ООО Достависта" и т.п.
    if (normalizedCarrierCode.includes('dostavista') || normalizedCarrierCode.includes('достависта')) {
        return registry.dostavista;
    }

    return baseExtension;
};




// WEBPACK FOOTER //
// ./App/pages/parcels/form_v3/carrierExtensions/index.js